import styled from "styled-components";

export const PageWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentContainer = styled.div`
  width: 70%;
  height: 95%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  color: white;
`;

export const HeaderSection = styled.div``;

export const Title = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
`;

export const Subtitle = styled.p`
  font-size: 1.75rem;
  line-height: 2.2rem;
  margin: 1rem 0;
  font-weight: 400;
`;

export const QRSection = styled.div`
  width: 24rem;
  height: 24rem;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  border-radius: 0.5rem;
`;

export const DisclaimerList = styled.ul`
  list-style-type: disc;
  font-size: 1.5rem;
  line-height: 2.2rem;
  color: #d1d3d4;
  margin-top: 1rem;
  text-align: left;
  margin-bottom: 1rem;
`;
